<script setup>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';

import Input from 'next/input/Input.vue';
import TextArea from 'next/textarea/TextArea.vue';

const { t } = useI18n();

const taskTypes = [
  { key: 'general_task', label: t('WGPT_TASKS.ADD.FORM.TYPE_OPTIONS.GENERAL') },
  {
    key: 'conversational_task',
    label: t('WGPT_TASKS.ADD.FORM.TYPE_OPTIONS.CONVERSATIONAL'),
  },
  {
    key: 'bot_followup_task',
    label: t('WGPT_TASKS.ADD.FORM.TYPE_OPTIONS.BOT_FOLLOWUP'),
  },
];

const state = reactive({
  name: '',
  description: '',
  type: 'general_task',
});

const rules = {
  name: { required },
  description: {},
  type: { required },
};

const v$ = useVuelidate(rules, state);

const validate = async () => {
  await v$.value.$validate();
  return !v$.value.$invalid;
};

defineExpose({ state, validate });
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <label class="text-sm font-medium text-n-slate-12 mb-1.5 block">
        {{ t('WGPT_TASKS.ADD.FORM.TYPE') }}
      </label>
      <div class="flex gap-2">
        <button
          v-for="option in taskTypes"
          :key="option.key"
          type="button"
          class="flex-1 px-3 py-2 rounded-lg border text-sm font-medium transition-colors"
          :class="
            state.type === option.key
              ? 'border-n-brand bg-n-alpha-2 text-n-blue-11'
              : 'border-n-weak text-n-slate-11 hover:border-n-slate-7'
          "
          @click="state.type = option.key"
        >
          {{ option.label }}
        </button>
      </div>
    </div>
    <Input
      v-model="state.name"
      :label="t('WGPT_TASKS.ADD.FORM.NAME')"
      :error="v$.name.$error ? v$.name.$errors[0].$message : ''"
      @blur="v$.name.$touch"
    />
    <TextArea
      v-model="state.description"
      :label="t('WGPT_TASKS.ADD.FORM.DESCRIPTION')"
      rows="3"
    />
  </div>
</template>
